import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, vModelCheckbox as _vModelCheckbox } from "vue"
import _imports_0 from '@/assets/filter.svg'
import _imports_1 from '@/assets/filterIcon_Disabled.svg'
import _imports_2 from '@/assets/deleteIcon.svg'
import _imports_3 from '@/assets/tooltip.svg'
import _imports_4 from '@/assets/sortBy.svg'
import _imports_5 from '@/assets/cancel.svg'


const _hoisted_1 = {
  key: 0,
  class: "mb-2"
}
const _hoisted_2 = { class: "flex flex-col flex-1 min-h-0 overflow-hidden" }
const _hoisted_3 = { class: "items-center justify-between flex h-6 flex-shrink-0" }
const _hoisted_4 = {
  key: 0,
  class: "title flex items-center"
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "flex flex-row-reverse gap-3" }
const _hoisted_7 = {
  key: 0,
  src: _imports_0,
  class: "filterIcon"
}
const _hoisted_8 = {
  key: 1,
  src: _imports_1,
  class: "filterIcon"
}
const _hoisted_9 = {
  key: 0,
  class: "mt-3 flex-shrink-0"
}
const _hoisted_10 = { class: "headerText" }
const _hoisted_11 = { class: "mt-5 bg-white border border-lightgrey relative rounded mapping-tabs-shell flex flex-col min-h-0 flex-1" }
const _hoisted_12 = { class: "pt-5 px-5 pb-3 flex flex-col min-h-0 w-full flex-1" }
const _hoisted_13 = {
  key: 0,
  class: "flex items-center justify-center w-full h-64"
}
const _hoisted_14 = { key: 1 }
const _hoisted_15 = {
  key: 0,
  class: "scrollBarColour tabStructure overflow-y-auto scrollbar-hidden"
}
const _hoisted_16 = {
  key: 0,
  class: "flex items-center justify-center w-full h-64"
}
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "flex flex-row mt-3" }
const _hoisted_19 = { class: "w-6/12" }
const _hoisted_20 = { class: "text-sm mt-2" }
const _hoisted_21 = { class: "w-6/12" }
const _hoisted_22 = { class: "text-sm mt-2" }
const _hoisted_23 = { class: "flex flex-row mt-3" }
const _hoisted_24 = { class: "w-6/12" }
const _hoisted_25 = { class: "text-sm mt-2" }
const _hoisted_26 = { class: "w-6/12" }
const _hoisted_27 = {
  key: 0,
  class: "text-sm mt-2"
}
const _hoisted_28 = {
  key: 1,
  class: "text-sm mt-2"
}
const _hoisted_29 = { class: "flex flex-row mt-3" }
const _hoisted_30 = { class: "w-6/12" }
const _hoisted_31 = {
  key: 1,
  class: "text-sm mt-2"
}
const _hoisted_32 = { class: "w-6/12" }
const _hoisted_33 = {
  key: 2,
  class: "text-sm mt-2"
}
const _hoisted_34 = { class: "flex flex-row mt-3" }
const _hoisted_35 = { class: "w-6/12" }
const _hoisted_36 = { class: "text-sm mt-2" }
const _hoisted_37 = { class: "w-6/12" }
const _hoisted_38 = { class: "text-sm mt-2" }
const _hoisted_39 = { class: "flex flex-row mt-3" }
const _hoisted_40 = { class: "w-6/12" }
const _hoisted_41 = { class: "text-sm mt-2" }
const _hoisted_42 = { class: "flex flex-row mt-3" }
const _hoisted_43 = { class: "w-6/12" }
const _hoisted_44 = { class: "text-sm mt-2" }
const _hoisted_45 = { class: "w-full mt-3" }
const _hoisted_46 = {
  key: 0,
  class: "text-sm mt-2"
}
const _hoisted_47 = {
  key: 1,
  class: "text-sm mt-2"
}
const _hoisted_48 = { class: "flex flex-row mt-3" }
const _hoisted_49 = { class: "w-full" }
const _hoisted_50 = { class: "text-sm mt-2" }
const _hoisted_51 = { class: "w-full mt-3" }
const _hoisted_52 = { class: "text-sm mt-2" }
const _hoisted_53 = { class: "flex flex-row mt-3" }
const _hoisted_54 = { class: "w-full" }
const _hoisted_55 = { class: "text-sm mt-2" }
const _hoisted_56 = {
  key: 1,
  class: "noScrollbar tabStructure1 mapping-tab-pane kpi-table-pane"
}
const _hoisted_57 = {
  key: 0,
  class: "flex items-center justify-center w-full h-64"
}
const _hoisted_58 = {
  key: 1,
  class: "tableCornerRadius bg-white table-container kpi-table-scroll flex-1 min-h-0"
}
const _hoisted_59 = { class: "table-container kpi-table-scroll" }
const _hoisted_60 = { class: "main-table" }
const _hoisted_61 = { class: "buttomStyle table-header-row" }
const _hoisted_62 = ["onClick"]
const _hoisted_63 = { key: 0 }
const _hoisted_64 = { key: 1 }
const _hoisted_65 = { key: 2 }
const _hoisted_66 = { key: 3 }
const _hoisted_67 = { key: 4 }
const _hoisted_68 = { key: 5 }
const _hoisted_69 = { key: 6 }
const _hoisted_70 = { key: 0 }
const _hoisted_71 = {
  key: 0,
  class: "table-filter-row"
}
const _hoisted_72 = ["onUpdate:modelValue"]
const _hoisted_73 = ["value"]
const _hoisted_74 = ["value"]
const _hoisted_75 = ["onUpdate:modelValue"]
const _hoisted_76 = ["value"]
const _hoisted_77 = ["value"]
const _hoisted_78 = ["onUpdate:modelValue"]
const _hoisted_79 = ["value"]
const _hoisted_80 = ["value"]
const _hoisted_81 = { key: 3 }
const _hoisted_82 = ["onUpdate:modelValue"]
const _hoisted_83 = { key: 0 }
const _hoisted_84 = { key: 0 }
const _hoisted_85 = { class: "cursor-pointer empty rowHeight" }
const _hoisted_86 = ["colspan"]
const _hoisted_87 = { class: "flex items-center justify-center w-full h-16" }
const _hoisted_88 = { key: 1 }
const _hoisted_89 = { class: "cursor-pointer rowHeight" }
const _hoisted_90 = ["colspan"]
const _hoisted_91 = {
  key: 2,
  class: "tbodylast"
}
const _hoisted_92 = { class: "checkBoxTd" }
const _hoisted_93 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_94 = ["value", "onChange"]
const _hoisted_95 = { key: 1 }
const _hoisted_96 = { key: 0 }
const _hoisted_97 = { class: "table-ellipsis" }
const _hoisted_98 = { class: "inline" }
const _hoisted_99 = { key: 1 }
const _hoisted_100 = { class: "flex justify-center items-center h-7 w-7" }
const _hoisted_101 = { class: "h-5 w-5" }
const _hoisted_102 = ["onClick"]
const _hoisted_103 = { key: 2 }
const _hoisted_104 = { class: "table-ellipsis pl-10" }
const _hoisted_105 = { class: "inline" }
const _hoisted_106 = {
  key: 3,
  class: "text-center w-full"
}
const _hoisted_107 = { key: 4 }
const _hoisted_108 = { class: "table-ellipsis" }
const _hoisted_109 = { class: "inline" }
const _hoisted_110 = { key: 5 }
const _hoisted_111 = { class: "table-ellipsis" }
const _hoisted_112 = { class: "inline" }
const _hoisted_113 = { key: 0 }
const _hoisted_114 = { key: 1 }
const _hoisted_115 = { key: 2 }
const _hoisted_116 = { key: 3 }
const _hoisted_117 = { key: 6 }
const _hoisted_118 = { class: "table-ellipsis" }
const _hoisted_119 = { class: "inline" }
const _hoisted_120 = { key: 7 }
const _hoisted_121 = ["onMousemove"]
const _hoisted_122 = ["onMousemove"]
const _hoisted_123 = {
  key: 2,
  class: "flex justify-center items-center bg-white opacity-0 lasttooltip absolute z-50 group-hover:opacity-100 border pointer-events-none"
}
const _hoisted_124 = {
  key: 3,
  class: "flex justify-center items-center bg-white opacity-0 lasttooltip absolute z-50 group-hover:opacity-100 border pointer-events-none cursor-pointer"
}
const _hoisted_125 = { key: 8 }
const _hoisted_126 = { class: "table-ellipsis" }
const _hoisted_127 = ["onMousemove"]
const _hoisted_128 = { key: 0 }
const _hoisted_129 = { key: 1 }
const _hoisted_130 = {
  key: 2,
  class: "noScrollbar tabStructure history-tab-pane mapping-tab-pane"
}
const _hoisted_131 = {
  key: 0,
  class: "flex items-center justify-center w-full h-64"
}
const _hoisted_132 = {
  key: 1,
  class: "history-tab-inner flex flex-col flex-1 min-h-0 overflow-hidden pt-2"
}
const _hoisted_133 = { class: "border-b border-lightgrey flex justify-between pb-2 flex-shrink-0" }
const _hoisted_134 = { class: "buttonposition flex justify-end items-center" }
const _hoisted_135 = { class: "history-entries-scroll flex-1 min-h-0 overflow-y-auto pr-2" }
const _hoisted_136 = { class: "flex" }
const _hoisted_137 = {
  key: 0,
  class: "initials"
}
const _hoisted_138 = {
  key: 1,
  class: "initials"
}
const _hoisted_139 = {
  key: 2,
  class: "initials"
}
const _hoisted_140 = { class: "logContainer w-93" }
const _hoisted_141 = { class: "flex" }
const _hoisted_142 = {
  key: 0,
  class: "font-semibold mt-1.5 text-xs"
}
const _hoisted_143 = {
  key: 1,
  class: "font-semibold mt-1.5 text-xs"
}
const _hoisted_144 = {
  key: 2,
  class: "mx-2 mt-1.5 text-xs"
}
const _hoisted_145 = { class: "pl-2" }
const _hoisted_146 = {
  key: 3,
  class: "mx-2 mt-1.5 text-xs"
}
const _hoisted_147 = { class: "pl-2" }
const _hoisted_148 = {
  key: 4,
  class: "mx-2 mt-1.5 text-xs"
}
const _hoisted_149 = { class: "pl-2" }
const _hoisted_150 = {
  key: 5,
  class: "mx-2 mt-1.5 text-xs"
}
const _hoisted_151 = { key: 6 }
const _hoisted_152 = { class: "mx-2 mt-1.5 text-xs" }
const _hoisted_153 = {
  key: 7,
  class: "mt-1.5 text-xs"
}
const _hoisted_154 = {
  key: 8,
  class: "mx-2 mt-1.5 text-xs"
}
const _hoisted_155 = { class: "pl-2" }
const _hoisted_156 = { class: "mt-3" }
const _hoisted_157 = { key: 1 }
const _hoisted_158 = {
  key: 9,
  class: "mx-2 mt-1.5 text-xs"
}
const _hoisted_159 = { class: "pl-2" }
const _hoisted_160 = { class: "mt-3" }
const _hoisted_161 = { key: 1 }
const _hoisted_162 = {
  key: 10,
  class: "mx-2 mt-1.5 text-xs"
}
const _hoisted_163 = { class: "pl-2" }
const _hoisted_164 = { class: "mt-3" }
const _hoisted_165 = {
  key: 0,
  class: "mt-1 text-xs"
}
const _hoisted_166 = { class: "ml-0.5" }
const _hoisted_167 = { key: 0 }
const _hoisted_168 = {
  key: 0,
  class: "card-footer-actions bottom-7 bg-white h-14 flex justify-between w-full rounded-b-sm flex-shrink-0",
  style: {"box-shadow":"0 -2px 10px rgba(0, 0, 0, 0.1)"}
}
const _hoisted_169 = {
  key: 0,
  class: "flex items-center text-sm ml-5"
}
const _hoisted_170 = {
  key: 1,
  class: "flex items-center px-5 mx-5"
}
const _hoisted_171 = ["disabled"]
const _hoisted_172 = { class: "flex items-center justify-between py-4 px-2 rounded" }
const _hoisted_173 = { class: "flex flex-col h-full" }
const _hoisted_174 = { class: "flex-1 overflow-auto" }
const _hoisted_175 = { class: "statuscontainer popupbodycontainer" }
const _hoisted_176 = { class: "formcontainer flex flex-col" }
const _hoisted_177 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_178 = { class: "w-full" }
const _hoisted_179 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_180 = {
  key: 0,
  class: "error-text"
}
const _hoisted_181 = {
  key: 1,
  class: "error-text text-xs"
}
const _hoisted_182 = {
  key: 1,
  class: "text-red-500"
}
const _hoisted_183 = { class: "row flex flex-row w-full mt-3 gap-3" }
const _hoisted_184 = { class: "w-6/12" }
const _hoisted_185 = { class: "w-6/12" }
const _hoisted_186 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_187 = {
  key: 0,
  class: "error-text"
}
const _hoisted_188 = { class: "row flex flex-row w-full mt-3 gap-3" }
const _hoisted_189 = { class: "w-6/12" }
const _hoisted_190 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_191 = {
  key: 0,
  class: "error-text"
}
const _hoisted_192 = { class: "w-6/12" }
const _hoisted_193 = { class: "controllabel" }
const _hoisted_194 = ["maxlength", "placeholder"]
const _hoisted_195 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_196 = {
  key: 0,
  class: "error-text"
}
const _hoisted_197 = {
  key: 1,
  class: "error-text"
}
const _hoisted_198 = { class: "row flex flex-row w-full mt-3 gap-3" }
const _hoisted_199 = { class: "w-6/12" }
const _hoisted_200 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_201 = {
  key: 0,
  class: "error-text"
}
const _hoisted_202 = {
  key: 1,
  class: "error-text"
}
const _hoisted_203 = {
  key: 0,
  class: "buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5"
}
const _hoisted_204 = {
  key: 1,
  class: "buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5"
}
const _hoisted_205 = { class: "flex items-center justify-between py-4 pl-2 pr-4 rounded" }
const _hoisted_206 = { class: "pl-2" }
const _hoisted_207 = { class: "flex flex-col h-full" }
const _hoisted_208 = { class: "flex-1 overflow-auto" }
const _hoisted_209 = { class: "statuscontainer popupbodycontainer" }
const _hoisted_210 = { class: "formcontainer flex flex-col" }
const _hoisted_211 = {
  key: 0,
  class: "row flex flex-row w-full"
}
const _hoisted_212 = { class: "w-full mt-3" }
const _hoisted_213 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_214 = {
  key: 0,
  class: "error-text"
}
const _hoisted_215 = {
  key: 1,
  class: "error-text text-xs"
}
const _hoisted_216 = { class: "formcontainer flex flex-col" }
const _hoisted_217 = { class: "row flex flex-row w-full mt-3" }
const _hoisted_218 = {
  key: 0,
  class: "mb-3 mt-2 text-sm"
}
const _hoisted_219 = { class: "flex flex-col" }
const _hoisted_220 = { class: "formcontainer flex flex-col" }
const _hoisted_221 = { class: "row flex flex-row w-full" }
const _hoisted_222 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_223 = {
  key: 0,
  class: "error-text"
}
const _hoisted_224 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_225 = {
  key: 0,
  class: "error-text"
}
const _hoisted_226 = { class: "formcontainer flex flex-col" }
const _hoisted_227 = { class: "row flex flex-row w-full" }
const _hoisted_228 = { class: "mb-3 mt-2 text-sm" }
const _hoisted_229 = { class: "mb-3 mt-2 text-sm" }
const _hoisted_230 = { class: "formcontainer flex flex-col" }
const _hoisted_231 = { class: "row flex flex-row w-full" }
const _hoisted_232 = {
  key: 0,
  class: "mb-3 mt-2 text-sm"
}
const _hoisted_233 = {
  key: 0,
  class: "mb-3 mt-2 text-sm"
}
const _hoisted_234 = { class: "formcontainer flex flex-col" }
const _hoisted_235 = { class: "mt-2" }
const _hoisted_236 = {
  key: 0,
  class: "mb-3 mt-2 text-sm"
}
const _hoisted_237 = { class: "w-full mb-3" }
const _hoisted_238 = {
  key: 0,
  class: "mt-2 text-sm"
}
const _hoisted_239 = { class: "w-full" }
const _hoisted_240 = {
  key: 0,
  class: "mb-3 mt-2 text-sm"
}
const _hoisted_241 = { class: "w-full" }
const _hoisted_242 = {
  key: 0,
  class: "mb-3 mt-2 text-sm"
}
const _hoisted_243 = {
  key: 0,
  class: "mb-3 mt-2 text-sm"
}
const _hoisted_244 = {
  key: 0,
  class: "mb-3 mt-2 text-sm"
}
const _hoisted_245 = {
  key: 0,
  class: "buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5"
}
const _hoisted_246 = { class: "flex items-center justify-between py-4 pl-2 pr-4 rounded" }
const _hoisted_247 = { class: "pl-2" }
const _hoisted_248 = { class: "flex flex-col h-full" }
const _hoisted_249 = { class: "flex-1 overflow-auto" }
const _hoisted_250 = { class: "statuscontainer popupbodycontainer" }
const _hoisted_251 = { class: "formcontainer flex flex-col" }
const _hoisted_252 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_253 = { class: "w-full" }
const _hoisted_254 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_255 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_256 = { class: "buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5" }
const _hoisted_257 = { class: "flex items-center justify-between py-4 pl-2 pr-4 rounded" }
const _hoisted_258 = { class: "pl-2" }
const _hoisted_259 = { class: "flex flex-col h-full" }
const _hoisted_260 = { class: "flex-1 overflow-auto" }
const _hoisted_261 = { class: "statuscontainer popupbodycontainer" }
const _hoisted_262 = { class: "formcontainer flex flex-col" }
const _hoisted_263 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_264 = { class: "w-full" }
const _hoisted_265 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_266 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_267 = { class: "buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_breadCrumb = _resolveComponent("breadCrumb")!
  const _component_Tab = _resolveComponent("Tab")!
  const _component_TabList = _resolveComponent("TabList")!
  const _component_dots_loader = _resolveComponent("dots-loader")!
  const _component_tool_tip = _resolveComponent("tool-tip")!
  const _component_pagination = _resolveComponent("pagination")!
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_TabPanels = _resolveComponent("TabPanels")!
  const _component_Tabs = _resolveComponent("Tabs")!
  const _component_Select = _resolveComponent("Select")!
  const _component_popup = _resolveComponent("popup")!
  const _component_ToggleSwitch = _resolveComponent("ToggleSwitch")!
  const _component_multiselect = _resolveComponent("multiselect")!
  const _component_MessageDialog = _resolveComponent("MessageDialog")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.modalMode ? 'details-in-modal mapping-modal' : 'pt-3 pl-5 pr-5')
  }, [
    (!_ctx.modalMode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_breadCrumb, { routesArray: _ctx.routesArray }, null, 8, ["routesArray"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (!_ctx.modalMode)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("h1", {
                class: _normalizeClass(_ctx.titleLength > 40? 'heading-ellipsis':'')
              }, _toDisplayString(_ctx.presentControlObj.controlTitle), 3)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_5)),
        _createElementVNode("div", _hoisted_6, [
          (_ctx.selectedTabIndex==1)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: _normalizeClass(["flex", 
              (_ctx.selectedTabIndex == 1 &&
                _ctx.kpisListFromOrgPresentControl.length != 0) ||
              (_ctx.selectedTabIndex == 2 && _ctx.sortedData.length != 0)
                ? 'filterButton'
                : 'filterButtondisabled pointer-events-none'
            ]),
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.filterOpen && _ctx.filterOpen(...args)))
              }, [
                ((_ctx.selectedTabIndex == 1 && _ctx.kpisListFromOrgPresentControl.length != 0) || (_ctx.selectedTabIndex == 2 && _ctx.sortedData.length != 0))
                  ? (_openBlock(), _createElementBlock("img", _hoisted_7))
                  : (_openBlock(), _createElementBlock("img", _hoisted_8)),
                _cache[57] || (_cache[57] = _createTextVNode(" Filters "))
              ], 2))
            : _createCommentVNode("", true),
          (_ctx.selectedTabIndex == 1 && _ctx.presentControlObj && _ctx.presentControlObj.isActive==true)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: _normalizeClass(["mr-3",  _ctx.showTotalKpisWeightage < 100 &&!_ctx.onSelectCheckBox ? 'btnprimary' : 'btndisabled pointer-events-none']),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addKPI(_ctx.kpi)))
              }, " Add ", 2))
            : _createCommentVNode("", true)
        ])
      ]),
      (!_ctx.modalMode)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.presentControlObj?.Description), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_Tabs, {
            value: _ctx.selectedTabIndex,
            "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedTabIndex) = $event)),
            scrollable: ""
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createVNode(_component_TabList, null, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.carouselHead, (tab, tabIndex) => {
                      return (_openBlock(), _createBlock(_component_Tab, {
                        key: tabIndex,
                        value: tabIndex,
                        onClick: ($event: any) => (_ctx.toggleTabs(tab.id))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(tab.displayName), 1)
                        ]),
                        _: 2
                      }, 1032, ["value", "onClick"]))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _createVNode(_component_TabPanels, null, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.carouselHead, (tab, tabIndex) => {
                    return (_openBlock(), _createBlock(_component_TabPanel, {
                      key: tabIndex,
                      value: tabIndex
                    }, {
                      default: _withCtx(() => [
                        (_ctx.dataLoading)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                              _createVNode(_component_dots_loader)
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                              (_ctx.selectedTabIndex==0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                    (_ctx.tabDataLoading)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                          _createVNode(_component_dots_loader)
                                        ]))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                          _createElementVNode("div", _hoisted_18, [
                                            _createElementVNode("div", _hoisted_19, [
                                              _cache[58] || (_cache[58] = _createElementVNode("label", { class: "font-semibold controllabel" }, "Tier", -1)),
                                              _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.presentControlObj.tier != undefined && _ctx.presentControlObj.tier != '' ? _ctx.presentControlObj.tier   : 'N/A'), 1)
                                            ]),
                                            _createElementVNode("div", _hoisted_21, [
                                              _cache[59] || (_cache[59] = _createElementVNode("label", { class: "font-extrabold text-xs" }, "Scope", -1)),
                                              _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.presentControlObj.tierTitle!= undefined&&_ctx.presentControlObj.tierTitle!= '' ? _ctx.presentControlObj.tierTitle: 'N/A'), 1)
                                            ])
                                          ]),
                                          _createElementVNode("div", _hoisted_23, [
                                            _createElementVNode("div", _hoisted_24, [
                                              _cache[60] || (_cache[60] = _createElementVNode("label", { class: "font-semibold controllabel" }, "CID", -1)),
                                              _createElementVNode("p", _hoisted_25, _toDisplayString(_ctx.presentControlObj.clientUniqueId != undefined ? _ctx.presentControlObj.clientUniqueId : 'N/A'), 1)
                                            ]),
                                            _createElementVNode("div", _hoisted_26, [
                                              _cache[61] || (_cache[61] = _createElementVNode("label", { class: "font-extrabold text-xs" }, "Frequency", -1)),
                                              (_ctx.presentControlObj.controlFrequency!= undefined&& _ctx.presentControlObj.controlFrequency!='' )
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_27, _toDisplayString(_ctx.getControlFrequency(_ctx.presentControlObj.controlFrequency)), 1))
                                                : (_openBlock(), _createElementBlock("p", _hoisted_28, "N/A"))
                                            ])
                                          ]),
                                          _createElementVNode("div", _hoisted_29, [
                                            _createElementVNode("div", _hoisted_30, [
                                              _cache[62] || (_cache[62] = _createElementVNode("label", { class: "font-extrabold text-xs" }, "Priority", -1)),
                                              (_ctx.presentControlObj.controlPriority && typeof _ctx.presentControlObj.controlPriority === 'number')
                                                ? (_openBlock(), _createElementBlock("div", {
                                                    key: 0,
                                                    class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-2", _ctx.colorLabelBg(_ctx.presentControlObj.controlPriority)])
                                                  }, [
                                                    _createElementVNode("div", {
                                                      class: _normalizeClass(["text-xs", _ctx.colorLabelText(_ctx.presentControlObj.controlPriority)])
                                                    }, _toDisplayString(_ctx.getProirityLabel(_ctx.presentControlObj.controlPriority)), 3)
                                                  ], 2))
                                                : (_openBlock(), _createElementBlock("div", _hoisted_31, "N/A"))
                                            ]),
                                            _createElementVNode("div", _hoisted_32, [
                                              _cache[63] || (_cache[63] = _createElementVNode("label", { class: "font-extrabold text-xs" }, "Status", -1)),
                                              (_ctx.presentControlObj.isActive && _ctx.presentControlObj.isActive==true)
                                                ? (_openBlock(), _createElementBlock("div", {
                                                    key: 0,
                                                    class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-2", _ctx.colorStatusBg(1)])
                                                  }, [
                                                    _createElementVNode("div", {
                                                      class: _normalizeClass(["text-xs", _ctx.colorStatusText(1)])
                                                    }, _toDisplayString(_ctx.getStatusLabel(1)), 3)
                                                  ], 2))
                                                : (_ctx.presentControlObj.isActive!=undefined && _ctx.presentControlObj.isActive==false)
                                                  ? (_openBlock(), _createElementBlock("div", {
                                                      key: 1,
                                                      class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-2", _ctx.colorStatusBg(2)])
                                                    }, [
                                                      _createElementVNode("div", {
                                                        class: _normalizeClass(["text-xs", _ctx.colorStatusText(2)])
                                                      }, _toDisplayString(_ctx.getStatusLabel(2)), 3)
                                                    ], 2))
                                                  : (_openBlock(), _createElementBlock("div", _hoisted_33, "N/A"))
                                            ])
                                          ]),
                                          _createElementVNode("div", _hoisted_34, [
                                            _createElementVNode("div", _hoisted_35, [
                                              _cache[64] || (_cache[64] = _createElementVNode("label", { class: "font-extrabold text-xs" }, "Class", -1)),
                                              _createElementVNode("p", _hoisted_36, _toDisplayString(_ctx.presentControlObj.controlClass != undefined&& _ctx.presentControlObj.controlClass!='' ? _ctx.presentControlObj.controlClass : 'N/A'), 1)
                                            ]),
                                            _createElementVNode("div", _hoisted_37, [
                                              _cache[65] || (_cache[65] = _createElementVNode("label", { class: "font-extrabold text-xs" }, "Family", -1)),
                                              _createElementVNode("p", _hoisted_38, _toDisplayString(_ctx.presentControlObj.controlFamily!= undefined && _ctx.presentControlObj.controlFamily!= '' ? _ctx.presentControlObj.controlFamily: 'N/A'), 1)
                                            ])
                                          ]),
                                          _createElementVNode("div", _hoisted_39, [
                                            _createElementVNode("div", _hoisted_40, [
                                              _cache[66] || (_cache[66] = _createElementVNode("label", { class: "font-extrabold text-xs" }, "Owner", -1)),
                                              _createElementVNode("p", _hoisted_41, _toDisplayString(_ctx.getOwnerName(_ctx.presentControlObj.controlOwner)), 1)
                                            ])
                                          ]),
                                          _createElementVNode("div", _hoisted_42, [
                                            _createElementVNode("div", _hoisted_43, [
                                              _cache[67] || (_cache[67] = _createElementVNode("label", { class: "font-extrabold text-xs" }, "Category", -1)),
                                              _createElementVNode("p", _hoisted_44, _toDisplayString(_ctx.presentControlObj.controlType != undefined && _ctx.presentControlObj.controlType != ''? _ctx.presentControlObj.controlType : 'N/A'), 1)
                                            ])
                                          ]),
                                          _createElementVNode("div", _hoisted_45, [
                                            _cache[68] || (_cache[68] = _createElementVNode("label", { class: "font-extrabold text-xs" }, "Description", -1)),
                                            ((_ctx.presentControlObj.Description!= undefined || _ctx.presentControlObj.controlDescription!=undefined)&& (_ctx.presentControlObj.Description!='' || _ctx.presentControlObj.controlDescription!='') )
                                              ? (_openBlock(), _createElementBlock("p", _hoisted_46, _toDisplayString(_ctx.presentControlObj.Description?_ctx.presentControlObj.Description:_ctx.presentControlObj.controlDescription), 1))
                                              : (_openBlock(), _createElementBlock("p", _hoisted_47, "N/A"))
                                          ]),
                                          _createElementVNode("div", _hoisted_48, [
                                            _createElementVNode("div", _hoisted_49, [
                                              _cache[69] || (_cache[69] = _createElementVNode("label", { class: "font-extrabold text-xs" }, "Policy/Procedure", -1)),
                                              _createElementVNode("p", _hoisted_50, _toDisplayString(_ctx.presentControlObj.controlPolicies != undefined && _ctx.presentControlObj.controlPolicies != '' ? _ctx.presentControlObj.controlPolicies : 'N/A'), 1)
                                            ])
                                          ]),
                                          _createElementVNode("div", _hoisted_51, [
                                            _cache[70] || (_cache[70] = _createElementVNode("label", { class: "font-extrabold text-xs" }, "Guidance", -1)),
                                            _createElementVNode("p", _hoisted_52, _toDisplayString(_ctx.presentControlObj.controlGuidance!= undefined &&  _ctx.presentControlObj.controlGuidance!=''? _ctx.presentControlObj.controlGuidance: 'N/A'), 1)
                                          ]),
                                          _createElementVNode("div", _hoisted_53, [
                                            _createElementVNode("div", _hoisted_54, [
                                              _cache[71] || (_cache[71] = _createElementVNode("label", { class: "font-extrabold text-xs" }, "Task", -1)),
                                              _createElementVNode("p", _hoisted_55, _toDisplayString(_ctx.presentControlObj.controlMaintenanceTask!= undefined && _ctx.presentControlObj.controlMaintenanceTask!= ''? _ctx.presentControlObj.controlMaintenanceTask: 'N/A'), 1)
                                            ])
                                          ])
                                        ]))
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.selectedTabIndex == 1)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                                    (_ctx.tabDataLoading)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                                          _createVNode(_component_dots_loader)
                                        ]))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_58, [
                                          _createElementVNode("div", _hoisted_59, [
                                            _createElementVNode("table", _hoisted_60, [
                                              _createElementVNode("thead", null, [
                                                _createElementVNode("tr", _hoisted_61, [
                                                  _cache[72] || (_cache[72] = _createElementVNode("th", { class: "widthCheckBox" }, null, -1)),
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.table1Heads, (column) => {
                                                    return (_openBlock(), _createElementBlock("th", {
                                                      scope: "col",
                                                      key: column,
                                                      class: _normalizeClass([[column == 'status' ? '' : '',_ctx.getColumnHeadWidth(column)], "bg-white cursor-pointer capitalize"])
                                                    }, [
                                                      _createElementVNode("div", {
                                                        onClick: ($event: any) => (_ctx.sort(column))
                                                      }, [
                                                        _createElementVNode("div", {
                                                          class: _normalizeClass(["flex", [column == 'status' || column == 'target' ? 'justify-center' : '']])
                                                        }, [
                                                          (column=='kpi_id')
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_63, "KPI ID"))
                                                            : _createCommentVNode("", true),
                                                          (column == 'description')
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_64, "KPI Name"))
                                                            : _createCommentVNode("", true),
                                                          (column == 'updatedon')
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_65, "Updated On"))
                                                            : (column == 'weightage')
                                                              ? (_openBlock(), _createElementBlock("div", _hoisted_66, " weightage (%) "))
                                                              : (column == 'target')
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_67, " Target "))
                                                                : (column == 'kpiType')
                                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_68, "KPI Type"))
                                                                  : (column == 'status')
                                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_69, "Status"))
                                                                    : _createCommentVNode("", true),
                                                          (column != 'deleteIcon')
                                                            ? (_openBlock(), _createElementBlock("div", {
                                                                key: 7,
                                                                class: _normalizeClass(["sort cursor-pointer",  (_ctx.className == column && _ctx.selectedTabIndex == 1 && _ctx.sortedAppliedKpisData.length != 0) || (_ctx.selectedTabIndex == 2 && _ctx.sortedData.length != 0) ? _ctx.classSort : 'opacity-50'])
                                                              }, null, 2))
                                                            : _createCommentVNode("", true)
                                                        ], 2)
                                                      ], 8, _hoisted_62),
                                                      (column == 'deleteIcon')
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_70))
                                                        : _createCommentVNode("", true)
                                                    ], 2))
                                                  }), 128))
                                                ]),
                                                (_ctx.showFilters)
                                                  ? (_openBlock(), _createElementBlock("tr", _hoisted_71, [
                                                      _cache[73] || (_cache[73] = _createElementVNode("td", null, null, -1)),
                                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.table1Heads, (name) => {
                                                        return (_openBlock(), _createElementBlock("td", {
                                                          class: "bg-white",
                                                          key: name
                                                        }, [
                                                          (
                          name == 'targetTimePeriod' ||
                          name == 'reportingFrequency'
                        )
                                                            ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                                                key: 0,
                                                                class: "inputboxstyling resize",
                                                                "onUpdate:modelValue": ($event: any) => ((_ctx.filters[name]) = $event)
                                                              }, [
                                                                _createElementVNode("option", {
                                                                  value: _ctx.filters.name,
                                                                  selected: "",
                                                                  disabled: "",
                                                                  hidden: ""
                                                                }, " Select ", 8, _hoisted_73),
                                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dbFrequency, (value, index) => {
                                                                  return (_openBlock(), _createElementBlock("option", {
                                                                    key: index,
                                                                    value: value.value
                                                                  }, _toDisplayString(value.key), 9, _hoisted_74))
                                                                }), 128))
                                                              ], 8, _hoisted_72)), [
                                                                [_vModelSelect, _ctx.filters[name]]
                                                              ])
                                                            : _createCommentVNode("", true),
                                                          (name == 'kpiType')
                                                            ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                                                key: 1,
                                                                class: _normalizeClass(["inputboxstyling resize", _ctx.filters[name] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect']),
                                                                "onUpdate:modelValue": ($event: any) => ((_ctx.filters[name]) = $event)
                                                              }, [
                                                                _createElementVNode("option", {
                                                                  value: _ctx.filters.name,
                                                                  selected: "",
                                                                  disabled: "",
                                                                  hidden: ""
                                                                }, "Select", 8, _hoisted_76),
                                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.kpiTypeOptions, (value, index) => {
                                                                  return (_openBlock(), _createElementBlock("option", {
                                                                    key: index,
                                                                    value: value.id
                                                                  }, _toDisplayString(value.name), 9, _hoisted_77))
                                                                }), 128))
                                                              ], 10, _hoisted_75)), [
                                                                [_vModelSelect, _ctx.filters[name]]
                                                              ])
                                                            : _createCommentVNode("", true),
                                                          (name == 'status')
                                                            ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                                                key: 2,
                                                                class: _normalizeClass(["inputboxstyling resize", _ctx.filters[name] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect']),
                                                                "onUpdate:modelValue": ($event: any) => ((_ctx.filters[name]) = $event)
                                                              }, [
                                                                _createElementVNode("option", {
                                                                  value: _ctx.filters.name,
                                                                  selected: "",
                                                                  disabled: "",
                                                                  hidden: ""
                                                                }, "Select", 8, _hoisted_79),
                                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeValues, (value, index) => {
                                                                  return (_openBlock(), _createElementBlock("option", {
                                                                    key: index,
                                                                    value: value.id
                                                                  }, _toDisplayString(value.value), 9, _hoisted_80))
                                                                }), 128))
                                                              ], 10, _hoisted_78)), [
                                                                [_vModelSelect, _ctx.filters[name]]
                                                              ])
                                                            : (name == 'deleteIcon' || name == 'weightage' ||name =='target'|| name=='kpiType' || name =='kpi_id')
                                                              ? (_openBlock(), _createElementBlock("div", _hoisted_81))
                                                              : _withDirectives((_openBlock(), _createElementBlock("input", {
                                                                  key: 4,
                                                                  type: "text",
                                                                  class: "searchForInputBoxStyling",
                                                                  placeholder: "Search",
                                                                  "onUpdate:modelValue": ($event: any) => ((_ctx.filters[name]) = $event)
                                                                }, null, 8, _hoisted_82)), [
                                                                  [_vModelText, _ctx.filters[name]]
                                                                ])
                                                        ]))
                                                      }), 128)),
                                                      (_ctx.name == 'deleteIcon')
                                                        ? (_openBlock(), _createElementBlock("td", _hoisted_83))
                                                        : _createCommentVNode("", true)
                                                    ]))
                                                  : _createCommentVNode("", true)
                                              ]),
                                              (_ctx.tableLoading)
                                                ? (_openBlock(), _createElementBlock("tbody", _hoisted_84, [
                                                    _createElementVNode("tr", _hoisted_85, [
                                                      _createElementVNode("td", {
                                                        class: "relative h-5",
                                                        colspan: _ctx.table1Heads.length + 1
                                                      }, [
                                                        _createElementVNode("div", _hoisted_87, [
                                                          _createVNode(_component_dots_loader)
                                                        ])
                                                      ], 8, _hoisted_86)
                                                    ])
                                                  ]))
                                                : (_ctx.columnObject || _ctx.sortedAppliedKpisData.length === 0)
                                                  ? (_openBlock(), _createElementBlock("tbody", _hoisted_88, [
                                                      _createElementVNode("tr", _hoisted_89, [
                                                        _createElementVNode("td", {
                                                          class: "relative h-10",
                                                          colspan: _ctx.table1Heads.length + 1
                                                        }, _cache[74] || (_cache[74] = [
                                                          _createElementVNode("div", { class: "flex justify-center" }, [
                                                            _createElementVNode("p", { class: "text-xs font-normal" }, "No Records Found")
                                                          ], -1)
                                                        ]), 8, _hoisted_90)
                                                      ])
                                                    ]))
                                                  : (_openBlock(), _createElementBlock("tbody", _hoisted_91, [
                                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedAppliedKpisData, (kpiData, index) => {
                                                        return (_openBlock(), _createElementBlock("tr", {
                                                          key: kpiData._id,
                                                          class: _normalizeClass([index % 2 == 0 ? 'odd' : 'even', "hoverEffectForCompleteRow"])
                                                        }, [
                                                          _createElementVNode("td", _hoisted_92, [
                                                            (kpiData.isActive==true)
                                                              ? (_openBlock(), _createElementBlock("div", _hoisted_93, [
                                                                  _withDirectives(_createElementVNode("input", {
                                                                    type: "checkbox",
                                                                    name: "checkbox",
                                                                    class: "checkbox cursor-pointer",
                                                                    value: kpiData.referenceKpiId || kpiData._id,
                                                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.checkedActiveKpis) = $event)),
                                                                    onChange: ($event: any) => (_ctx.changedActiveKpiInput(0, $event, kpiData.weightage))
                                                                  }, null, 40, _hoisted_94), [
                                                                    [_vModelCheckbox, _ctx.checkedActiveKpis]
                                                                  ])
                                                                ]))
                                                              : (_openBlock(), _createElementBlock("div", _hoisted_95, _cache[75] || (_cache[75] = [
                                                                  _createElementVNode("div", { class: "checkbox bg-lightgrey flex items-center justify-center cursor-not-allowed" }, [
                                                                    _createElementVNode("div", { class: "border-disabledgrey horizontalCheckBox w-1/2" })
                                                                  ], -1)
                                                                ])))
                                                          ]),
                                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.table1Heads, (column) => {
                                                            return (_openBlock(), _createElementBlock("td", {
                                                              key: column,
                                                              onMouseout: _cache[3] || (_cache[3] = ($event: any) => (_ctx.doFalse())),
                                                              class: _normalizeClass(["cursor-pointer relative", column == 'target' || column == 'status' ? 'text-center' : ''])
                                                            }, [
                                                              (
                          column == 'targetTimePeriod' ||
                          column == 'reportingFrequency')
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
                                                                    _createElementVNode("div", _hoisted_97, [
                                                                      _createElementVNode("div", _hoisted_98, _toDisplayString(_ctx.dbFrequency.find((itemOne) => {
                                return itemOne.value == kpiData[column];
                              })?.key||'N/A'), 1)
                                                                    ])
                                                                  ]))
                                                                : (column == 'deleteIcon')
                                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_99, [
                                                                      _createElementVNode("div", _hoisted_100, [
                                                                        _createElementVNode("div", _hoisted_101, [
                                                                          _createElementVNode("img", {
                                                                            src: _imports_2,
                                                                            class: "cursor-pointer h-5 w-5",
                                                                            onClick: ($event: any) => (_ctx.deleteKpiForControl(kpiData))
                                                                          }, null, 8, _hoisted_102)
                                                                        ])
                                                                      ])
                                                                    ]))
                                                                  : (column == 'weightage')
                                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_103, [
                                                                        _createElementVNode("div", _hoisted_104, [
                                                                          _createElementVNode("div", _hoisted_105, _toDisplayString(kpiData[column]), 1)
                                                                        ])
                                                                      ]))
                                                                    : (column == 'target')
                                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_106, _toDisplayString(_ctx.formatKpiTargetForDisplay(kpiData)), 1))
                                                                      : (column == 'kpi_id')
                                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_107, [
                                                                            _createElementVNode("div", _hoisted_108, [
                                                                              _createElementVNode("div", _hoisted_109, _toDisplayString(kpiData.kpi_id ? kpiData.kpi_id :'N/A'), 1)
                                                                            ])
                                                                          ]))
                                                                        : (column == 'kpiType')
                                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_110, [
                                                                              _createElementVNode("div", _hoisted_111, [
                                                                                _createElementVNode("div", _hoisted_112, [
                                                                                  (kpiData.kpiType == 10603)
                                                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_113, "Custom"))
                                                                                    : (kpiData.kpiType == 10604)
                                                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_114, "Built-in"))
                                                                                      : (kpiData.kpiType == 2)
                                                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_115, "Built-in"))
                                                                                        : (_openBlock(), _createElementBlock("div", _hoisted_116, "N/A"))
                                                                                ])
                                                                              ])
                                                                            ]))
                                                                          : (column == 'updatedon')
                                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_117, [
                                                                                _createElementVNode("div", _hoisted_118, [
                                                                                  _createElementVNode("div", _hoisted_119, _toDisplayString(_ctx.formatTime(kpiData[column])), 1)
                                                                                ])
                                                                              ]))
                                                                            : (column=='status')
                                                                              ? (_openBlock(), _createElementBlock("div", _hoisted_120, [
                                                                                  (kpiData[column] == true)
                                                                                    ? (_openBlock(), _createElementBlock("div", {
                                                                                        key: 0,
                                                                                        class: "rounded-full w-5 h-5 bg-active mx-auto",
                                                                                        onMousemove: ($event: any) => (_ctx.toolTip(column, $event, index, kpiData, 'circleButton'))
                                                                                      }, null, 40, _hoisted_121))
                                                                                    : (_openBlock(), _createElementBlock("div", {
                                                                                        key: 1,
                                                                                        class: "rounded-full w-5 h-5 bg-error mx-auto",
                                                                                        onMousemove: ($event: any) => (_ctx.toolTip(column, $event, index, kpiData, 'circleButton'))
                                                                                      }, null, 40, _hoisted_122)),
                                                                                  (kpiData[column] == true && _ctx.pop == true)
                                                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_123, _cache[76] || (_cache[76] = [
                                                                                        _createElementVNode("img", {
                                                                                          src: _imports_3,
                                                                                          alt: "",
                                                                                          class: "absolute text-black bottom-full left-0 -mb-1 h-3.5 w-3"
                                                                                        }, null, -1),
                                                                                        _createElementVNode("span", { class: "text-black text-center text-xs" }, null, -1),
                                                                                        _createTextVNode(" Active ")
                                                                                      ])))
                                                                                    : _createCommentVNode("", true),
                                                                                  (kpiData[column] == false && _ctx.pop == true)
                                                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_124, _cache[77] || (_cache[77] = [
                                                                                        _createElementVNode("img", {
                                                                                          src: _imports_3,
                                                                                          alt: "",
                                                                                          class: "absolute text-black bottom-full left-0 -mb-1 h-3.5 w-3"
                                                                                        }, null, -1),
                                                                                        _createElementVNode("span", { class: "text-black text-center text-xs" }, null, -1),
                                                                                        _createTextVNode(" Inactive ")
                                                                                      ])))
                                                                                    : _createCommentVNode("", true)
                                                                                ]))
                                                                              : (_openBlock(), _createElementBlock("div", _hoisted_125, [
                                                                                  _createElementVNode("div", _hoisted_126, [
                                                                                    _createElementVNode("p", {
                                                                                      class: "inline fullText",
                                                                                      onMousemove: ($event: any) => (_ctx.toolTip(column, $event, index, kpiData, 'text'))
                                                                                    }, _toDisplayString(kpiData[column]), 41, _hoisted_127)
                                                                                  ])
                                                                                ]))
                                                            ], 34))
                                                          }), 128))
                                                        ], 2))
                                                      }), 128))
                                                    ]))
                                            ])
                                          ]),
                                          (_ctx.toolTipActive)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_128, [
                                                _createVNode(_component_tool_tip, { tipText: _ctx.toolTipText }, null, 8, ["tipText"])
                                              ]))
                                            : _createCommentVNode("", true),
                                          (_ctx.sortedAppliedKpisData.length != 0)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_129, [
                                                _createVNode(_component_pagination, {
                                                  dynamicPagination: _ctx.dynamicPagination,
                                                  onCurrentPageUpdate: _ctx.paginationUpdations,
                                                  sortedData: _ctx.sortedAppliedKpisData
                                                }, null, 8, ["dynamicPagination", "onCurrentPageUpdate", "sortedData"])
                                              ]))
                                            : _createCommentVNode("", true)
                                        ]))
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.selectedTabIndex == 2)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_130, [
                                    (_ctx.tabDataLoading)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_131, [
                                          _createVNode(_component_dots_loader)
                                        ]))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_132, [
                                          _createElementVNode("div", _hoisted_133, [
                                            _cache[80] || (_cache[80] = _createElementVNode("div", { class: "flex items-center justify-center" }, [
                                              _createElementVNode("div", null, [
                                                _createElementVNode("p", { class: "header" }, "History")
                                              ])
                                            ], -1)),
                                            _createElementVNode("div", _hoisted_134, [
                                              (_ctx.newHistory)
                                                ? (_openBlock(), _createElementBlock("button", {
                                                    key: 0,
                                                    class: _normalizeClass(["filterButton w-24 flex taskEditButtons", _ctx.workLogObject?.[0] && Object.keys(_ctx.workLogObject[0]).includes('history') && _ctx.workLogObject[0].history?.length !== 0 ? 'btnprimary' : 'pointer-events-none']),
                                                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.sortWorkLog()))
                                                  }, _cache[78] || (_cache[78] = [
                                                    _createElementVNode("img", {
                                                      src: _imports_4,
                                                      class: "h-3 mr-2.5"
                                                    }, null, -1),
                                                    _createTextVNode(" Oldest ")
                                                  ]), 2))
                                                : _createCommentVNode("", true),
                                              (!_ctx.newHistory)
                                                ? (_openBlock(), _createElementBlock("button", {
                                                    key: 1,
                                                    class: "filterButton w-24 flex taskEditButtons",
                                                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.sortWorkLog()))
                                                  }, _cache[79] || (_cache[79] = [
                                                    _createElementVNode("img", {
                                                      src: _imports_4,
                                                      class: "h-3 mr-2.5 rotate-180"
                                                    }, null, -1),
                                                    _createTextVNode(" Newest ")
                                                  ])))
                                                : _createCommentVNode("", true)
                                            ])
                                          ]),
                                          _createElementVNode("div", _hoisted_135, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.workLogObject[0]?.history, (work) => {
                                              return (_openBlock(), _createElementBlock("div", {
                                                key: work,
                                                class: "bg-white py-4 mb-0.5 border-lightgrey border-b"
                                              }, [
                                                _createElementVNode("div", _hoisted_136, [
                                                  (Object.keys(work).includes('updatedBy'))
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_137, _toDisplayString(_ctx.extractInitials(work.name)), 1))
                                                    : (Object.keys(work).includes('createdBy'))
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_138, _toDisplayString(_ctx.extractInitials(work.name)), 1))
                                                      : _createCommentVNode("", true),
                                                  (Object.keys(work).includes('activatedBy'))
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_139, _toDisplayString(_ctx.extractInitials(work.name)), 1))
                                                    : _createCommentVNode("", true),
                                                  _createElementVNode("div", _hoisted_140, [
                                                    _createElementVNode("div", _hoisted_141, [
                                                      (Object.keys(work).includes('activatedBy'))
                                                        ? (_openBlock(), _createElementBlock("p", _hoisted_142, _toDisplayString(work.name), 1))
                                                        : _createCommentVNode("", true),
                                                      (Object.keys(work).includes('kpiStatus'))
                                                        ? (_openBlock(), _createElementBlock("p", _hoisted_143, _toDisplayString(work.name), 1))
                                                        : _createCommentVNode("", true),
                                                      (Object.keys(work).includes('actionType') && work.actionType==10301 && Object.keys(work).includes('controlStatus') && work.controlStatus==true &&!Object.keys(work).includes('previousPriority')&& !Object.keys(work).includes('previousFrequency'))
                                                        ? (_openBlock(), _createElementBlock("p", _hoisted_144, [
                                                            _cache[81] || (_cache[81] = _createTextVNode(_toDisplayString('Activated the '))),
                                                            _createElementVNode("b", null, _toDisplayString(`${work.clientUniqueId}`), 1),
                                                            _cache[82] || (_cache[82] = _createTextVNode(" " + _toDisplayString('on'))),
                                                            _createElementVNode("span", _hoisted_145, [
                                                              _createElementVNode("b", null, _toDisplayString(_ctx.formatHistoryTime(work.activatedAt)), 1)
                                                            ])
                                                          ]))
                                                        : _createCommentVNode("", true),
                                                      (Object.keys(work).includes('actionType') && work.actionType==10303 && Object.keys(work).includes('controlStatus') && work.controlStatus==false)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_146, [
                                                            _createElementVNode("p", null, [
                                                              _cache[83] || (_cache[83] = _createTextVNode(_toDisplayString('Deactivated the '))),
                                                              _createElementVNode("b", null, _toDisplayString(`${work.clientUniqueId}`), 1),
                                                              _cache[84] || (_cache[84] = _createElementVNode("span", { class: "ml-2" }, _toDisplayString('on'), -1)),
                                                              _createElementVNode("span", _hoisted_147, [
                                                                _createElementVNode("b", null, _toDisplayString(_ctx.formatHistoryTime(work.activatedAt)), 1)
                                                              ])
                                                            ])
                                                          ]))
                                                        : _createCommentVNode("", true),
                                                      (Object.keys(work).includes('actionType') && work.actionType==10302 && Object.keys(work).includes('controlStatus') && work.controlStatus==true && (!work.previousPriority&& !work.previousFrequency))
                                                        ? (_openBlock(), _createElementBlock("p", _hoisted_148, [
                                                            _cache[85] || (_cache[85] = _createTextVNode(_toDisplayString('Activated the '))),
                                                            _createElementVNode("b", null, _toDisplayString(`${work.clientUniqueId}`), 1),
                                                            _cache[86] || (_cache[86] = _createTextVNode(" " + _toDisplayString('on'))),
                                                            _createElementVNode("span", _hoisted_149, [
                                                              _createElementVNode("b", null, _toDisplayString(_ctx.formatHistoryTime(work.activatedAt)), 1)
                                                            ])
                                                          ]))
                                                        : _createCommentVNode("", true),
                                                      (Object.keys(work).includes('kpiStatus') && work.kpiStatus==true)
                                                        ? (_openBlock(), _createElementBlock("p", _hoisted_150, [
                                                            _cache[87] || (_cache[87] = _createTextVNode(" Activated the kpi: ")),
                                                            _createElementVNode("b", null, _toDisplayString(`${work.kpiTitle}`), 1),
                                                            _cache[88] || (_cache[88] = _createTextVNode(" on ")),
                                                            _createElementVNode("b", null, _toDisplayString(_ctx.formatHistoryTime(work.updatedAt)), 1)
                                                          ]))
                                                        : (Object.keys(work).includes('kpiStatus') && work.kpiStatus == false)
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_151, [
                                                              _createElementVNode("p", _hoisted_152, [
                                                                _cache[89] || (_cache[89] = _createTextVNode(" Inactivated the kpi: ")),
                                                                _createElementVNode("b", null, _toDisplayString(work.kpiTitle), 1),
                                                                _cache[90] || (_cache[90] = _createTextVNode(" at ")),
                                                                _createElementVNode("b", null, _toDisplayString(_ctx.formatHistoryTime(work.updatedAt)), 1)
                                                              ])
                                                            ]))
                                                          : (Object.keys(work).includes('actionType') && work.actionType==10301 &&Object.keys(work).includes('controlStatus') && work.controlStatus==false )
                                                            ? (_openBlock(), _createElementBlock("p", _hoisted_153, [
                                                                _cache[91] || (_cache[91] = _createTextVNode(" Inactivated the ")),
                                                                _createElementVNode("b", null, _toDisplayString(`${work.clientUniqueId}`), 1),
                                                                _cache[92] || (_cache[92] = _createTextVNode(" at ")),
                                                                _createElementVNode("b", null, _toDisplayString(_ctx.formatHistoryTime(work.updatedAt)), 1)
                                                              ]))
                                                            : (Object.keys(work).includes('previousPriority'))
                                                              ? (_openBlock(), _createElementBlock("div", _hoisted_154, [
                                                                  _createElementVNode("p", null, [
                                                                    _cache[93] || (_cache[93] = _createTextVNode(_toDisplayString('Updated the ') + " ")),
                                                                    _createElementVNode("b", null, _toDisplayString(work.clientUniqueId), 1),
                                                                    _cache[94] || (_cache[94] = _createElementVNode("span", { class: "ml-2" }, _toDisplayString('on'), -1)),
                                                                    _createElementVNode("span", _hoisted_155, [
                                                                      _createElementVNode("b", null, _toDisplayString(_ctx.formatHistoryTime(work.activatedAt)), 1)
                                                                    ])
                                                                  ]),
                                                                  _createElementVNode("div", _hoisted_156, [
                                                                    (work.previousPriority&&typeof work.previousPriority!='string')
                                                                      ? (_openBlock(), _createElementBlock("span", {
                                                                          key: 0,
                                                                          class: _normalizeClass([_ctx.colorLabelBg(work.previousPriority), "inline-flex items-center justify-center rounded h-5 w-24 mx-1 lablePadding"])
                                                                        }, [
                                                                          _createElementVNode("span", {
                                                                            class: _normalizeClass([_ctx.colorLabelText(work.previousPriority), "text-xs"])
                                                                          }, _toDisplayString(_ctx.getProirityLabel(work.previousPriority)), 3)
                                                                        ], 2))
                                                                      : (_openBlock(), _createElementBlock("span", _hoisted_157, " N/A ")),
                                                                    _cache[95] || (_cache[95] = _createTextVNode(" " + _toDisplayString(' to ') + " ")),
                                                                    _createElementVNode("span", {
                                                                      class: _normalizeClass([_ctx.colorLabelBg(work.currentPriority), "inline-flex items-center justify-center rounded h-5 w-24 mx-1 lablePadding"])
                                                                    }, [
                                                                      _createElementVNode("span", {
                                                                        class: _normalizeClass([_ctx.colorLabelText(work.currentPriority), "text-xs"])
                                                                      }, _toDisplayString(_ctx.getProirityLabel(work.currentPriority)), 3)
                                                                    ], 2)
                                                                  ])
                                                                ]))
                                                              : (work.activatedBy && work.previousPriority && work.controlStatus==false)
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_158, [
                                                                    _createElementVNode("p", null, [
                                                                      _cache[96] || (_cache[96] = _createTextVNode(_toDisplayString('Updated the ') + " ")),
                                                                      _createElementVNode("b", null, _toDisplayString(work.clientUniqueId), 1),
                                                                      _cache[97] || (_cache[97] = _createElementVNode("span", { class: "ml-2" }, _toDisplayString('on'), -1)),
                                                                      _createElementVNode("span", _hoisted_159, [
                                                                        _createElementVNode("b", null, _toDisplayString(_ctx.formatHistoryTime(work.updatedAt)), 1)
                                                                      ])
                                                                    ]),
                                                                    _createElementVNode("div", _hoisted_160, [
                                                                      (work.previousPriority&&typeof work.previousPriority!='string')
                                                                        ? (_openBlock(), _createElementBlock("span", {
                                                                            key: 0,
                                                                            class: _normalizeClass([_ctx.colorLabelBg(work.previousPriority), "inline-flex items-center justify-center rounded h-5 w-24 mx-1 lablePadding"])
                                                                          }, [
                                                                            _createElementVNode("span", {
                                                                              class: _normalizeClass([_ctx.colorLabelText(work.previousPriority), "text-xs"])
                                                                            }, _toDisplayString(_ctx.getProirityLabel(work.previousPriority)), 3)
                                                                          ], 2))
                                                                        : (_openBlock(), _createElementBlock("span", _hoisted_161, " N/A ")),
                                                                      _cache[98] || (_cache[98] = _createTextVNode(" " + _toDisplayString(' to ') + " ")),
                                                                      _createElementVNode("span", {
                                                                        class: _normalizeClass([_ctx.colorLabelBg(work.currentPriority), "inline-flex items-center justify-center rounded h-5 w-24 mx-1 lablePadding"])
                                                                      }, [
                                                                        _createElementVNode("span", {
                                                                          class: _normalizeClass([_ctx.colorLabelText(work.currentPriority), "text-xs"])
                                                                        }, _toDisplayString(_ctx.getProirityLabel(work.currentPriority)), 3)
                                                                      ], 2),
                                                                      _cache[99] || (_cache[99] = _createElementVNode("b", null, "in InactiveControls", -1))
                                                                    ])
                                                                  ]))
                                                                : ((work.updatedBy|| work.activatedBy)&&work.previousFrequency)
                                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_162, [
                                                                      _createElementVNode("p", null, [
                                                                        _cache[100] || (_cache[100] = _createTextVNode(_toDisplayString('Updated the ') + " ")),
                                                                        _createElementVNode("b", null, _toDisplayString(work.clientUniqueId), 1),
                                                                        _cache[101] || (_cache[101] = _createElementVNode("span", { class: "ml-2" }, _toDisplayString('on'), -1)),
                                                                        _createElementVNode("span", _hoisted_163, [
                                                                          _createElementVNode("b", null, _toDisplayString(_ctx.formatHistoryTime(work.updatedAt || work.activatedAt)), 1)
                                                                        ])
                                                                      ]),
                                                                      _createElementVNode("div", _hoisted_164, [
                                                                        _cache[102] || (_cache[102] = _createTextVNode(_toDisplayString('from') + " ")),
                                                                        _createElementVNode("span", null, [
                                                                          _createElementVNode("b", null, _toDisplayString(_ctx.getFrequencyValue(work.previousFrequency)), 1)
                                                                        ]),
                                                                        _cache[103] || (_cache[103] = _createTextVNode(" " + _toDisplayString(' to ') + " ")),
                                                                        _createElementVNode("span", null, [
                                                                          _createElementVNode("b", null, _toDisplayString(_ctx.getFrequencyValue(work.currentFrequency)), 1)
                                                                        ])
                                                                      ])
                                                                    ]))
                                                                  : _createCommentVNode("", true)
                                                    ]),
                                                    ((Object.keys(work).includes('actionType') && work.actionType==10303 && Object.keys(work).includes('controlStatus') && work.controlStatus==false) || (Object.keys(work).includes('kpiStatus') && work.kpiStatus == false))
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_165, [
                                                          _cache[104] || (_cache[104] = _createElementVNode("b", null, "Justification:", -1)),
                                                          _createElementVNode("span", _hoisted_166, _toDisplayString(work.justification || 'N/A'), 1)
                                                        ]))
                                                      : _createCommentVNode("", true)
                                                  ])
                                                ])
                                              ]))
                                            }), 128))
                                          ]),
                                          (_ctx.toolTipActive)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_167, [
                                                _createVNode(_component_tool_tip, { tipText: _ctx.toolTipText }, null, 8, ["tipText"])
                                              ]))
                                            : _createCommentVNode("", true)
                                        ]))
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                      ]),
                      _: 2
                    }, 1032, ["value"]))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["value"])
        ]),
        (_ctx.selectedTabIndex == 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_168, [
              (!_ctx.tabDataLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_169, " Total Weightage is: " + _toDisplayString(_ctx.showTotalKpisWeightage) + " % ", 1))
                : _createCommentVNode("", true),
              (!_ctx.tabDataLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_170, [
                    _createElementVNode("button", {
                      class: _normalizeClass(["mr-2", _ctx.arraysAreEqual ? 'btndisabled pointer-events-none' : 'btnprimary']),
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.cancelActiveKpis()))
                    }, "Cancel", 2),
                    _createElementVNode("button", {
                      class: _normalizeClass(_ctx.arraysAreEqual? 'btndisabled pointer-events-none' : 'btnprimary'),
                      disabled: _ctx.clickOnButton,
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.saveKpisForControl(_ctx.checkedActiveKpis,'manual')))
                    }, "Save", 10, _hoisted_171)
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.showPopup)
        ? (_openBlock(), _createBlock(_component_popup, {
            key: 1,
            popUp: _ctx.showPopup
          }, {
            header: _withCtx(() => [
              _createElementVNode("div", _hoisted_172, [
                _cache[106] || (_cache[106] = _createElementVNode("h1", { class: "pl-2" }, "Manage KPI", -1)),
                _createElementVNode("button", {
                  class: "float-right text-3xl",
                  onClick: _cache[9] || (_cache[9] = ($event: any) => {
                _ctx.onCancelbtn();
                _ctx.showPopup = false;
              })
                }, _cache[105] || (_cache[105] = [
                  _createElementVNode("img", {
                    src: _imports_5,
                    class: "h-5 w-5 cursor-pointer"
                  }, null, -1)
                ]))
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_173, [
                _createElementVNode("div", _hoisted_174, [
                  _createElementVNode("fieldset", null, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_175, [
                          _createElementVNode("div", _hoisted_176, [
                            _createElementVNode("div", _hoisted_177, [
                              _createElementVNode("div", _hoisted_178, [
                                _cache[108] || (_cache[108] = _createElementVNode("label", { class: "controllabel" }, "KPI Name", -1)),
                                _withDirectives(_createElementVNode("textarea", {
                                  type: "text",
                                  class: _normalizeClass(["inputboxstyling h-20 max-h-48 mt-2", {
                          'is-invalid': _ctx.v$.addingKpiObj.description.$error || _ctx.isDuplicateData.description,
                        }]),
                                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.addingKpiObj.description) = $event)),
                                  onInput: _cache[11] || (_cache[11] = ($event: any) => (_ctx.v$.addingKpiObj.description.$touch())),
                                  placeholder: "KPI Name"
                                }, null, 34), [
                                  [
                                    _vModelText,
                                    _ctx.addingKpiObj.description,
                                    void 0,
                                    { trim: true }
                                  ]
                                ]),
                                (_ctx.v$.addingKpiObj.description.$error)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_179, [
                                      (_ctx.v$.addingKpiObj.description.required.$invalid)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_180, "Required"))
                                        : (_ctx.v$.addingKpiObj.description.restrictCharacters100.$invalid)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_181, "Charcter Limit is exceeded"))
                                          : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.isDuplicateData.description)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_182, _cache[107] || (_cache[107] = [
                                      _createElementVNode("div", { class: "error-text text-xs" }, "KPI Name already exists.", -1)
                                    ])))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_183, [
                              _createElementVNode("div", _hoisted_184, [
                                _cache[109] || (_cache[109] = _createElementVNode("label", { class: "controllabel" }, "Kpi Id", -1)),
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  class: "inputboxstyling mt-2 disiableState kpi-form-field",
                                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.addingKpiObj.kpi_id) = $event)),
                                  placeholder: "Number",
                                  disabled: ""
                                }, null, 512), [
                                  [
                                    _vModelText,
                                    _ctx.addingKpiObj.kpi_id,
                                    void 0,
                                    { trim: true }
                                  ]
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_185, [
                                _cache[110] || (_cache[110] = _createElementVNode("label", { class: "controllabel" }, "Target Type", -1)),
                                _createVNode(_component_Select, {
                                  modelValue: _ctx.addingKpiObj.targetType,
                                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.addingKpiObj.targetType) = $event)),
                                  options: _ctx.targetTypeOptions,
                                  optionLabel: "label",
                                  optionValue: "value",
                                  placeholder: "Please select the option",
                                  class: _normalizeClass(["w-full custom-multiselect userSelect mt-2 kpi-operator-select", { 'is-invalid': _ctx.v$.addingKpiObj.targetType.$error }]),
                                  onChange: _cache[14] || (_cache[14] = ($event: any) => (_ctx.targetGreaterThanZero(_ctx.addingKpiObj.target)))
                                }, null, 8, ["modelValue", "options", "class"]),
                                (_ctx.v$.addingKpiObj.targetType.$error)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_186, [
                                      (_ctx.v$.addingKpiObj.targetType.required.$invalid)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_187, "Required"))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_188, [
                              _createElementVNode("div", _hoisted_189, [
                                _cache[111] || (_cache[111] = _createElementVNode("label", { class: "controllabel" }, "Condition", -1)),
                                _createVNode(_component_Select, {
                                  modelValue: _ctx.addingKpiObj.kpiCondition,
                                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.addingKpiObj.kpiCondition) = $event)),
                                  options: _ctx.kpiConditionOptions,
                                  optionLabel: "label",
                                  optionValue: "value",
                                  placeholder: "Please select the option",
                                  class: _normalizeClass(["w-full custom-multiselect userSelect mt-2 kpi-operator-select", { 'is-invalid': _ctx.v$.addingKpiObj.kpiCondition.$error }])
                                }, null, 8, ["modelValue", "options", "class"]),
                                (_ctx.v$.addingKpiObj.kpiCondition.$error)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_190, [
                                      (_ctx.v$.addingKpiObj.kpiCondition.required.$invalid)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_191, "Required"))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_192, [
                                _createElementVNode("label", _hoisted_193, _toDisplayString(_ctx.addingKpiObj.targetType === 'number' ? 'Target' : 'Target(%)'), 1),
                                _withDirectives(_createElementVNode("input", {
                                  type: "number",
                                  class: _normalizeClass(["inputboxstyling mt-2 kpi-form-field", {
                          'is-invalid': _ctx.v$.addingKpiObj.target.$error || _ctx.validTargetError || _ctx.targetNumberLessThanZero,
                        }]),
                                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.addingKpiObj.target) = $event)),
                                  maxlength: _ctx.addingKpiObj.targetType === 'number' ? 10 : 3,
                                  ref: "editTarget",
                                  placeholder: _ctx.addingKpiObj.targetType === 'number' ? 'Target' : 'Target (%)',
                                  onKeyup: _cache[17] || (_cache[17] = ($event: any) => {_ctx.targetLessThanZero(_ctx.addingKpiObj.target); _ctx.targetGreaterThanZero(_ctx.addingKpiObj.target); _ctx.handleTargetInput})
                                }, null, 42, _hoisted_194), [
                                  [
                                    _vModelText,
                                    _ctx.addingKpiObj.target,
                                    void 0,
                                    { trim: true }
                                  ]
                                ]),
                                (_ctx.v$.addingKpiObj.target.$error || _ctx.validTargetError || _ctx.targetNumberLessThanZero)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_195, [
                                      (_ctx.v$.addingKpiObj.target.required.$invalid)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_196, _toDisplayString(_ctx.addingKpiObj.targetType === 'number' ? 'Target is required' : 'Target (%) is required'), 1))
                                        : _createCommentVNode("", true),
                                      ((_ctx.validTargetError && !_ctx.v$.addingKpiObj.target.required.$invalid) || (_ctx.targetNumberLessThanZero == true && !_ctx.v$.addingKpiObj.target.required.$invalid))
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_197, _toDisplayString(_ctx.addingKpiObj.targetType === 'number' ? 'Target is Invalid' : 'Target(%) is Invalid'), 1))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_198, [
                              _createElementVNode("div", _hoisted_199, [
                                _cache[112] || (_cache[112] = _createElementVNode("label", { class: "controllabel" }, "Weightage (%)", -1)),
                                _withDirectives(_createElementVNode("input", {
                                  type: "number",
                                  class: _normalizeClass(["inputboxstyling mt-2 kpi-form-field", {
                          'is-invalid': _ctx.v$.addingKpiObj.weightage.$error || _ctx.validtaionWeightageError || _ctx.numberLessThanZero,
                        }]),
                                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.addingKpiObj.weightage) = $event)),
                                  maxlength: "3",
                                  ref: "editWeight",
                                  placeholder: "Weightage (%)",
                                  onKeyup: _cache[19] || (_cache[19] = ($event: any) => (_ctx.weightageLessThanZero(_ctx.addingKpiObj.weightage) || _ctx.weightageGreaterThanZero(_ctx.addingKpiObj) && _ctx.handleInput))
                                }, null, 34), [
                                  [
                                    _vModelText,
                                    _ctx.addingKpiObj.weightage,
                                    void 0,
                                    { trim: true }
                                  ]
                                ]),
                                (_ctx.v$.addingKpiObj.weightage.$error || _ctx.validtaionWeightageError || _ctx.numberLessThanZero)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_200, [
                                      (_ctx.v$.addingKpiObj.weightage.required.$invalid)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_201, " Weightage (%) is required "))
                                        : _createCommentVNode("", true),
                                      ((_ctx.validtaionWeightageError && !_ctx.v$.addingKpiObj.weightage.required.$invalid) || (_ctx.numberLessThanZero == true && !_ctx.v$.addingKpiObj.weightage.required.$invalid))
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_202, " Weightage(%) is Invalid "))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _cache[113] || (_cache[113] = _createElementVNode("div", { class: "w-6/12" }, null, -1))
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", null, [
                  _cache[114] || (_cache[114] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey mx-5" }, null, -1)),
                  (_ctx.buttonVisible==false)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_203, [
                        _createElementVNode("button", {
                          class: _normalizeClass(["mr-1.5", 
                  _ctx.disableStatus
                    ? 'btnprimary'
                    : 'btndisabled pointer-events-none'
                ]),
                          onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.onCancelbtn()))
                        }, " Cancel ", 2),
                        _createElementVNode("button", {
                          class: _normalizeClass(
                  _ctx.disableStatus
                    ? 'btnprimary'
                    : 'btndisabled pointer-events-none'
                ),
                          onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.addOrUpdateKpiForControlManual(_ctx.addingKpiObj)))
                        }, " Update ", 2)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_204, [
                        _createElementVNode("button", {
                          class: _normalizeClass(["mr-1.5", 
                  _ctx.disableStatus
                    ? 'btndisabled pointer-events-none'
                    : 'btnprimary'
                ]),
                          onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.onCancelbtn()))
                        }, " Reset ", 2),
                        _createElementVNode("button", {
                          class: _normalizeClass(
                  _ctx.disableStatus
                    ? 'btndisabled pointer-events-none'
                    : 'btnprimary'
                ),
                          onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.addOrUpdateKpiForControlManual(_ctx.addingKpiObj)))
                        }, " Save ", 2)
                      ]))
                ])
              ])
            ]),
            _: 1
          }, 8, ["popUp"]))
        : _createCommentVNode("", true),
      (_ctx.controlEditPopup)
        ? (_openBlock(), _createBlock(_component_popup, {
            key: 2,
            popUp: _ctx.controlEditPopup
          }, {
            header: _withCtx(() => [
              _createElementVNode("div", _hoisted_205, [
                _createElementVNode("h1", _hoisted_206, _toDisplayString(_ctx.presentControlObj?.controlTitle||'N/A'), 1),
                _createElementVNode("button", {
                  class: "float-right text-3xl",
                  onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.onCancelbtnCustom('close')))
                }, _cache[115] || (_cache[115] = [
                  _createElementVNode("img", {
                    src: _imports_5,
                    class: "h-5 w-5 cursor-pointer"
                  }, null, -1)
                ]))
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_207, [
                _createElementVNode("div", _hoisted_208, [
                  _createElementVNode("fieldset", null, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_209, [
                        _createElementVNode("div", _hoisted_210, [
                          (_ctx.addControlpopup==true)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_211, [
                                _createElementVNode("div", _hoisted_212, [
                                  _cache[116] || (_cache[116] = _createElementVNode("label", { class: "controllabel" }, "Title", -1)),
                                  _withDirectives(_createElementVNode("textarea", {
                                    type: "text-area",
                                    class: _normalizeClass(["inputboxstyling mt-2", {
                                            'is-invalid': _ctx.v$.presentControlObj.controlTitle.$error
                                        }]),
                                    placeholder: "Title",
                                    onInput: _cache[25] || (_cache[25] = ($event: any) => (_ctx.v$.presentControlObj.controlTitle.$touch())),
                                    "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.presentControlObj.controlTitle) = $event))
                                  }, null, 34), [
                                    [
                                      _vModelText,
                                      _ctx.presentControlObj.controlTitle,
                                      void 0,
                                      { trim: true }
                                    ]
                                  ]),
                                  (_ctx.v$.presentControlObj.controlTitle.$error)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_213, [
                                        (_ctx.v$.presentControlObj.controlTitle.required.$invalid)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_214, "Required"))
                                          : (_ctx.v$.presentControlObj.controlTitle && _ctx.v$.presentControlObj.controlTitle.restrictCharacters100.$invalid)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_215, "Charcter Limit is exceeded"))
                                            : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_216, [
                            _createElementVNode("div", _hoisted_217, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["w-6/12", {'topspace': _ctx.addControlpopup}])
                              }, [
                                _cache[117] || (_cache[117] = _createElementVNode("label", { class: "controllabel" }, "Number", -1)),
                                (_ctx.addControlpopup==false)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_218, _toDisplayString(_ctx.presentControlObj?.clientUniqueId || 'N/A'), 1))
                                  : _withDirectives((_openBlock(), _createElementBlock("input", {
                                      key: 1,
                                      type: "text",
                                      class: "inputboxstyling mt-2",
                                      "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.presentControlObj.controlNumber) = $event)),
                                      onInput: _cache[28] || (_cache[28] = ($event: any) => (_ctx.v$.presentControlObj.controlNumber.$touch())),
                                      placeholder: "Number",
                                      disabled: ""
                                    }, null, 544)), [
                                      [
                                        _vModelText,
                                        _ctx.presentControlObj.controlNumber,
                                        void 0,
                                        { trim: true }
                                      ]
                                    ])
                              ], 2),
                              _createElementVNode("div", {
                                class: _normalizeClass(["w-6/12 pl-4", {'topspace': _ctx.addControlpopup}])
                              }, [
                                _createElementVNode("div", _hoisted_219, [
                                  _cache[118] || (_cache[118] = _createElementVNode("label", { class: "controllabel mr-2 mb-2" }, "Status", -1)),
                                  _createVNode(_component_ToggleSwitch, {
                                    modelValue: _ctx.controlsEditData.isActive,
                                    "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.controlsEditData.isActive) = $event)),
                                    checked: _ctx.controlsEditData.isActive
                                  }, null, 8, ["modelValue", "checked"])
                                ])
                              ], 2)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_220, [
                            _createElementVNode("div", _hoisted_221, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["w-3/6", {'topspace': _ctx.addControlpopup}])
                              }, [
                                _cache[119] || (_cache[119] = _createElementVNode("label", { class: "controllabel" }, "Frequency", -1)),
                                _createVNode(_component_Select, {
                                  modelValue: _ctx.controlsEditData.controlFrequency,
                                  "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.controlsEditData.controlFrequency) = $event)),
                                  options: _ctx.dbFrequency,
                                  optionLabel: "key",
                                  optionValue: "value",
                                  placeholder: "Please select one",
                                  class: _normalizeClass(["w-full custom-multiselect userSelect mt-2", {
                                                  'is-invalid': _ctx.v$.controlsEditData.controlFrequency.$error
                                                  }])
                                }, null, 8, ["modelValue", "options", "class"]),
                                (_ctx.v$.controlsEditData.controlFrequency.$error)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_222, [
                                      (_ctx.v$.controlsEditData.controlFrequency.required.$invalid)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_223, "Required"))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ], 2),
                              _createElementVNode("div", {
                                class: _normalizeClass(["w-6/12 pl-4", {'topspace': _ctx.addControlpopup}])
                              }, [
                                _cache[120] || (_cache[120] = _createElementVNode("label", { class: "controllabel" }, "Priority", -1)),
                                _createVNode(_component_Select, {
                                  modelValue: _ctx.controlsEditData.controlPriority,
                                  "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.controlsEditData.controlPriority) = $event)),
                                  options: _ctx.dbPriority,
                                  optionLabel: "key",
                                  optionValue: "value",
                                  placeholder: "Please select one",
                                  class: _normalizeClass(["w-full custom-multiselect userSelect mt-2", {
                                            'is-invalid': _ctx.v$.controlsEditData.controlPriority.$error
                                            }])
                                }, null, 8, ["modelValue", "options", "class"]),
                                (_ctx.v$.controlsEditData.controlPriority.$error)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_224, [
                                      (_ctx.v$.controlsEditData.controlPriority.required.$invalid)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_225, "Required"))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ], 2)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_226, [
                            _createElementVNode("div", _hoisted_227, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["w-6/12 mt-3", {'topspace': _ctx.addControlpopup}])
                              }, [
                                _cache[121] || (_cache[121] = _createElementVNode("label", { class: "controllabel" }, "Tier", -1)),
                                _createElementVNode("div", _hoisted_228, _toDisplayString(_ctx.presentControlObj.tier|| 'N/A'), 1)
                              ], 2),
                              _createElementVNode("div", {
                                class: _normalizeClass(["w-6/12 pl-4 mt-3", {'topspace': _ctx.addControlpopup}])
                              }, [
                                _cache[122] || (_cache[122] = _createElementVNode("label", { class: "controllabel" }, "Scope", -1)),
                                _createElementVNode("div", _hoisted_229, _toDisplayString(_ctx.presentControlObj.tierTitle|| 'N/A'), 1)
                              ], 2)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_230, [
                            _createElementVNode("div", _hoisted_231, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["w-6/12", {'topspace': _ctx.addControlpopup}])
                              }, [
                                _cache[124] || (_cache[124] = _createElementVNode("label", { class: "controllabel" }, "Family", -1)),
                                (_ctx.addControlpopup==false)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_232, _toDisplayString(_ctx.presentControlObj.controlFamily || 'N/A'), 1))
                                  : (_openBlock(), _createBlock(_component_multiselect, {
                                      key: 1,
                                      modelValue: _ctx.presentControlObj.controlFamily,
                                      "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.presentControlObj.controlFamily) = $event)),
                                      options: _ctx.filteredControlFamilyOptions,
                                      showNoOptions: false,
                                      onSearchChange: _ctx.asyncFindControlFamily,
                                      multiple: false,
                                      searchable: true,
                                      "open-direction": "bottom",
                                      hideArrow: false,
                                      placeholder: "Family",
                                      class: "custom-multiselect userSelect mt-2"
                                    }, {
                                      noResult: _withCtx(() => _cache[123] || (_cache[123] = [
                                        _createElementVNode("span", { class: "text-xs" }, "No Families Found", -1)
                                      ])),
                                      _: 1
                                    }, 8, ["modelValue", "options", "onSearchChange"]))
                              ], 2),
                              _createElementVNode("div", {
                                class: _normalizeClass(["w-3/6 pl-4", {'topspace': _ctx.addControlpopup}])
                              }, [
                                _cache[125] || (_cache[125] = _createElementVNode("label", { class: "controllabel" }, "Class", -1)),
                                (_ctx.addControlpopup==false)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_233, _toDisplayString(_ctx.presentControlObj.controlClass || 'N/A'), 1))
                                  : _withDirectives((_openBlock(), _createElementBlock("input", {
                                      key: 1,
                                      type: "text",
                                      class: "inputboxstyling mt-2",
                                      onInput: _cache[33] || (_cache[33] = ($event: any) => (_ctx.v$.presentControlObj.controlClass.$touch())),
                                      placeholder: "Class",
                                      "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.presentControlObj.controlClass) = $event))
                                    }, null, 544)), [
                                      [
                                        _vModelText,
                                        _ctx.presentControlObj.controlClass,
                                        void 0,
                                        { trim: true }
                                      ]
                                    ])
                              ], 2)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_234, [
                            _createElementVNode("div", null, [
                              _createElementVNode("div", {
                                class: _normalizeClass({'topspace': _ctx.addControlpopup})
                              }, [
                                _createElementVNode("div", null, [
                                  _cache[126] || (_cache[126] = _createElementVNode("label", { class: "controllabel" }, "Category", -1)),
                                  _createElementVNode("div", _hoisted_235, [
                                    (_ctx.addControlpopup==false)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_236, _toDisplayString(_ctx.presentControlObj?.controlType || 'N/A'), 1))
                                      : _withDirectives((_openBlock(), _createElementBlock("input", {
                                          key: 1,
                                          type: "text",
                                          class: "inputboxstyling",
                                          onInput: _cache[35] || (_cache[35] = ($event: any) => (_ctx.v$.presentControlObj.controlType.$touch())),
                                          "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.presentControlObj.controlType) = $event)),
                                          placeholder: "Type"
                                        }, null, 544)), [
                                          [
                                            _vModelText,
                                            _ctx.presentControlObj.controlType,
                                            void 0,
                                            { trim: true }
                                          ]
                                        ])
                                  ])
                                ])
                              ], 2)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_237, [
                            _cache[127] || (_cache[127] = _createElementVNode("label", { class: "font-extrabold text-xs" }, "Description", -1)),
                            (_ctx.addControlpopup==false)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_238, _toDisplayString(_ctx.presentControlObj.Description || 'N/A'), 1))
                              : _withDirectives((_openBlock(), _createElementBlock("textarea", {
                                  key: 1,
                                  type: "text-area",
                                  class: "inputboxstyling mt-2",
                                  onInput: _cache[37] || (_cache[37] = ($event: any) => (_ctx.v$.presentControlObj.Description.$touch())),
                                  placeholder: "Description",
                                  "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.presentControlObj.Description) = $event))
                                }, "                                    ", 544)), [
                                  [
                                    _vModelText,
                                    _ctx.presentControlObj.Description,
                                    void 0,
                                    { trim: true }
                                  ]
                                ])
                          ]),
                          _createElementVNode("div", {
                            class: _normalizeClass(["row flex flex-row w-full", {'topspace': _ctx.addControlpopup}])
                          }, [
                            _createElementVNode("div", _hoisted_239, [
                              _cache[128] || (_cache[128] = _createElementVNode("label", { class: "controllabel" }, "Policies", -1)),
                              (_ctx.addControlpopup==false)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_240, _toDisplayString(_ctx.presentControlObj.controlPolicies || 'N/A'), 1))
                                : _withDirectives((_openBlock(), _createElementBlock("textarea", {
                                    key: 1,
                                    type: "text-area",
                                    class: _normalizeClass(["inputboxstyling h-24 mt-2", {
                                            'is-invalid': _ctx.v$.presentControlObj.controlPolicies.$error
                                        }]),
                                    placeholder: "Policies",
                                    "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.presentControlObj.controlPolicies) = $event)),
                                    onInput: _cache[40] || (_cache[40] = ($event: any) => (_ctx.v$.presentControlObj.controlPolicies.$touch()))
                                  }, "                                    ", 34)), [
                                    [
                                      _vModelText,
                                      _ctx.presentControlObj.controlPolicies,
                                      void 0,
                                      { trim: true }
                                    ]
                                  ])
                            ])
                          ], 2),
                          _createElementVNode("div", {
                            class: _normalizeClass(["row flex flex-row w-full", {'topspace': _ctx.addControlpopup}])
                          }, [
                            _createElementVNode("div", _hoisted_241, [
                              _cache[129] || (_cache[129] = _createElementVNode("label", { class: "controllabel" }, "Guidance", -1)),
                              (_ctx.addControlpopup==false)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_242, _toDisplayString(_ctx.presentControlObj.controlGuidance || 'N/A'), 1))
                                : _withDirectives((_openBlock(), _createElementBlock("textarea", {
                                    key: 1,
                                    type: "text-area",
                                    class: _normalizeClass(["inputboxstyling h-24 mt-2", {
                                            'is-invalid': _ctx.v$.presentControlObj.controlGuidance.$error
                                        }]),
                                    placeholder: "Guidance",
                                    "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.presentControlObj.controlGuidance) = $event)),
                                    onInput: _cache[42] || (_cache[42] = ($event: any) => (_ctx.v$.presentControlObj.controlGuidance.$touch()))
                                  }, "                                    ", 34)), [
                                    [
                                      _vModelText,
                                      _ctx.presentControlObj.controlGuidance,
                                      void 0,
                                      { trim: true }
                                    ]
                                  ])
                            ])
                          ], 2),
                          _createElementVNode("div", {
                            class: _normalizeClass(["w-full col-md-6", {'topspace': _ctx.addControlpopup}])
                          }, [
                            _cache[131] || (_cache[131] = _createElementVNode("label", { class: "controllabel" }, "Frameworks", -1)),
                            (_ctx.addControlpopup==false)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_243, _toDisplayString(_ctx.presentControlObj.controlOptionFrameWork || 'N/A'), 1))
                              : (_openBlock(), _createBlock(_component_multiselect, {
                                  key: 1,
                                  modelValue: _ctx.presentControlObj.controlOptionFrameWork,
                                  "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.presentControlObj.controlOptionFrameWork) = $event)),
                                  onSelect: _cache[44] || (_cache[44] = ($event: any) => (_ctx.getFrameworkControls(_ctx.presentControlObj.controlOptionFrameWork))),
                                  multiple: false,
                                  options: _ctx.frameWorksList,
                                  searchable: true,
                                  "open-direction": "bottom",
                                  "close-on-select": true,
                                  "clear-on-select": true,
                                  "show-labels": false,
                                  placeholder: "Frameworks",
                                  class: "custom-multiselect mt-2"
                                }, {
                                  noResult: _withCtx(() => _cache[130] || (_cache[130] = [
                                    _createElementVNode("span", { class: "text-xs" }, "No Frameworks Found", -1)
                                  ])),
                                  _: 1
                                }, 8, ["modelValue", "options"]))
                          ], 2),
                          _createElementVNode("div", {
                            class: _normalizeClass(["w-full col-md-6", {'topspace': _ctx.addControlpopup}])
                          }, [
                            _cache[133] || (_cache[133] = _createElementVNode("label", { class: "controllabel" }, "Controls", -1)),
                            (_ctx.addControlpopup==false)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_244, _toDisplayString(_ctx.presentControlObj.frameworkControls || 'N/A'), 1))
                              : (_openBlock(), _createBlock(_component_multiselect, {
                                  key: 1,
                                  modelValue: _ctx.presentControlObj.frameworkControls,
                                  "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.presentControlObj.frameworkControls) = $event)),
                                  multiple: false,
                                  options: _ctx.frameworkControls,
                                  searchable: true,
                                  "open-direction": "bottom",
                                  "close-on-select": true,
                                  "show-labels": false,
                                  placeholder: "Controls",
                                  class: "custom-multiselect mt-2"
                                }, {
                                  noResult: _withCtx(() => _cache[132] || (_cache[132] = [
                                    _createElementVNode("span", { class: "text-xs" }, "No Controls Found", -1)
                                  ])),
                                  _: 1
                                }, 8, ["modelValue", "options"]))
                          ], 2)
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", null, [
                  _cache[134] || (_cache[134] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey mx-5" }, null, -1)),
                  (_ctx.presentControlObj._id)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_245, [
                        _createElementVNode("button", {
                          class: _normalizeClass(["btnprimary mr-1.5", JSON.stringify(_ctx.controlsEditData)!==JSON.stringify(_ctx.dummyControlObj) ? 'btnprimary' : 'btndisabled pointer-events-none']),
                          onClick: _cache[46] || (_cache[46] = ($event: any) => (_ctx.onCancelbtnCustom('activecancel')))
                        }, "Reset", 2),
                        _createElementVNode("button", {
                          class: _normalizeClass(["btnprimary", JSON.stringify(_ctx.controlsEditData)!==JSON.stringify(_ctx.dummyControlObj) ? 'btnprimary' : 'btndisabled pointer-events-none']),
                          onClick: _cache[47] || (_cache[47] = ($event: any) => (_ctx.editCustomControl(_ctx.controlsEditData,'edit')))
                        }, "Save", 2)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _: 1
          }, 8, ["popUp"]))
        : _createCommentVNode("", true),
      (_ctx.deActivatingPopup)
        ? (_openBlock(), _createBlock(_component_popup, {
            key: 3,
            popUp: _ctx.deActivatingPopup
          }, {
            header: _withCtx(() => [
              _createElementVNode("div", _hoisted_246, [
                _createElementVNode("h1", _hoisted_247, _toDisplayString(_ctx.presentControlObj?.controlTitle||'N/A'), 1),
                _createElementVNode("button", {
                  class: "float-right text-3xl",
                  onClick: _cache[48] || (_cache[48] = ($event: any) => (_ctx.onCancelbtnCustom('deactivateclose')))
                }, _cache[135] || (_cache[135] = [
                  _createElementVNode("img", {
                    src: _imports_5,
                    class: "h-5 w-5 cursor-pointer"
                  }, null, -1)
                ]))
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_248, [
                _createElementVNode("div", _hoisted_249, [
                  _createElementVNode("fieldset", null, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_250, [
                        _createElementVNode("div", _hoisted_251, [
                          _createElementVNode("div", _hoisted_252, [
                            _createElementVNode("div", _hoisted_253, [
                              _cache[136] || (_cache[136] = _createElementVNode("label", { class: "controllabel" }, "Reason/Justification for Deactivating the control", -1)),
                              _withDirectives(_createElementVNode("textarea", {
                                type: "text-area",
                                class: _normalizeClass(["inputboxstyling mt-2", {
                                        'is-invalid': _ctx.v$.deActiveControlObject.justification.$error
                                        }]),
                                placeholder: "Reason/Justification for Deactivating the control",
                                "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.deActiveControlObject.justification) = $event))
                              }, " ", 2), [
                                [_vModelText, _ctx.deActiveControlObject.justification]
                              ]),
                              (_ctx.v$.deActiveControlObject.justification.$error)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_254, [
                                    (_ctx.v$.deActiveControlObject.justification.required.$invalid)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_255, "Required"))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", null, [
                  _cache[137] || (_cache[137] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey mx-5" }, null, -1)),
                  _createElementVNode("div", _hoisted_256, [
                    _createElementVNode("button", {
                      class: _normalizeClass(["btnprimary mr-1.5", _ctx.isObjectEmpty(_ctx.deActiveControlObject) ? 'btnprimary' : 'btndisabled pointer-events-none']),
                      onClick: _cache[50] || (_cache[50] = ($event: any) => (_ctx.onCancelbtnCustom('deactivecancel')))
                    }, " Reset ", 2),
                    _createElementVNode("button", {
                      class: _normalizeClass(["btnprimary", _ctx.isObjectEmpty(_ctx.deActiveControlObject) ? 'btnprimary' : 'btndisabled pointer-events-none']),
                      onClick: _cache[51] || (_cache[51] = ($event: any) => (_ctx.editCustomControl(_ctx.deActiveControlObject,'deActive')))
                    }, " Save ", 2)
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["popUp"]))
        : _createCommentVNode("", true),
      (_ctx.deActivatingKPIPopup)
        ? (_openBlock(), _createBlock(_component_popup, {
            key: 4,
            popUp: _ctx.deActivatingKPIPopup
          }, {
            header: _withCtx(() => [
              _createElementVNode("div", _hoisted_257, [
                _createElementVNode("h1", _hoisted_258, _toDisplayString(_ctx.deactivatingKpiName), 1),
                _createElementVNode("button", {
                  class: "float-right text-3xl",
                  onClick: _cache[52] || (_cache[52] = ($event: any) => (_ctx.onCancelbtnCustom('deactivateclose')))
                }, _cache[138] || (_cache[138] = [
                  _createElementVNode("img", {
                    src: _imports_5,
                    class: "h-5 w-5 cursor-pointer"
                  }, null, -1)
                ]))
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_259, [
                _createElementVNode("div", _hoisted_260, [
                  _createElementVNode("fieldset", null, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_261, [
                        _createElementVNode("div", _hoisted_262, [
                          _createElementVNode("div", _hoisted_263, [
                            _createElementVNode("div", _hoisted_264, [
                              _cache[139] || (_cache[139] = _createElementVNode("label", { class: "controllabel" }, "Reason/Justification for Deactivating the KPI", -1)),
                              _withDirectives(_createElementVNode("textarea", {
                                type: "text-area",
                                class: _normalizeClass(["inputboxstyling mt-2", {
                                        'is-invalid': _ctx.v$.deActiveKPIObject.justification.$error
                                        }]),
                                placeholder: "Reason/Justification for Deactivating the KPI",
                                "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((_ctx.deActiveKPIObject.justification) = $event))
                              }, " ", 2), [
                                [
                                  _vModelText,
                                  _ctx.deActiveKPIObject.justification,
                                  void 0,
                                  { trim: true }
                                ]
                              ]),
                              (_ctx.v$.deActiveKPIObject.justification.$error)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_265, [
                                    (_ctx.v$.deActiveKPIObject.justification.required.$invalid)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_266, "Required"))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", null, [
                  _cache[140] || (_cache[140] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey mx-5" }, null, -1)),
                  _createElementVNode("div", _hoisted_267, [
                    _createElementVNode("button", {
                      class: _normalizeClass(["btnprimary mr-1.5", _ctx.isObjectEmpty(_ctx.deActiveKPIObject) ? 'btnprimary' : 'btndisabled pointer-events-none']),
                      onClick: _cache[54] || (_cache[54] = ($event: any) => (_ctx.onCancelbtnCustom('deactivecancel')))
                    }, " Reset ", 2),
                    _createElementVNode("button", {
                      class: _normalizeClass(["btnprimary", _ctx.isObjectEmpty(_ctx.deActiveKPIObject) ? 'btnprimary' : 'btndisabled pointer-events-none']),
                      onClick: _cache[55] || (_cache[55] = 
//@ts-ignore
(...args) => (_ctx.confirmDeactivateKpis && _ctx.confirmDeactivateKpis(...args)))
                    }, " Save ", 2)
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["popUp"]))
        : _createCommentVNode("", true),
      _createVNode(_component_MessageDialog, {
        visible: _ctx.showMessageDialog,
        "onUpdate:visible": _cache[56] || (_cache[56] = ($event: any) => ((_ctx.showMessageDialog) = $event)),
        activeControls: [],
        mode: _ctx.messageDialogMode,
        tasks: _ctx.inProgressTasks,
        loadingMessage: "Inactivating Control please wait a moment",
        onCancel: _ctx.onMessageDialogCancel,
        onOk: _ctx.onMessageDialogOk,
        onOkTasks: _ctx.onMessageDialogOkTasks
      }, null, 8, ["visible", "mode", "tasks", "onCancel", "onOk", "onOkTasks"])
    ])
  ], 2))
}